export const FooterData = function () {
  return (
    <div>
      <h1 style={{ color: "black" }}>
        INFORMARE PRIVIND PRELUCRAREA DATELOR CU CARACTER PERSONAL
      </h1>
      <p style={{ color: "black", marginTop: "20px" }}>
        Urmatoarea informare este conceputa pentru a va aduce la cunostinta
        aspectele cu privire la prelucrarea datelor dvs. personale si la
        drepturile dvs. privind aceasta prelucrare în conformitate cu
        Regulamentul general 2016/679 privind protectia datelor (“GDPR”) si
        legislatia nationala în vigoare.
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        1. Informatii generale
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Noi, societatea SC. HYBRIMI AUTOSERV S.R.L. reprezentam operatorul în
        conformitate cu GDPR. Emailul prin care putem fi contactati este
        hybrimiautoserv@gmail.com, iar numarul de telefon este +40 (758) 840
        708. .
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        2. Scopul prelucrarii și categoriile de date prelucrate:
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        In vederea indeplinirii obligatiilor legale ale Societatii; ,in scopul
        urmaririi intereselor legitime ale Societatii, Furnizarea de informatii
        cu privire la oferte comerciale, Furnizarea de informatii cu privire la
        evenimentele Societatii
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        În aceste scopuri pot fi prelucrate următoarele categorii de date:
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Numele și prenumele, codul numeric personal, data nașterii, sexul,
        documentul de identitate, funcţia, adresa, e-mailul, numerele de telefon
        fix și/sau mobil, numărul de fax; Contactul dvs. cu noi, cum ar fi un
        e-mail, o notificare, o solicitare printr-un mesaj sau alte evidențe ale
        unui contact cu noi; Informații privind contul dvs., cum ar fi datele
        plăților datorate sau primite, numerele de cont sau alte informații în
        legătură cu contul dvs. sau care sunt incluse în portalul nostru de
        gestionare a relaţiei comerciale cu fiecare client; Preferințele dvs.
        pentru anumite produse, servicii și stil de viață atunci când ne spuneți
        care sunt acestea sau atunci când presupunem care sunt, în baza modului
        în care solicitati prestarea serviciilor de catre SC. HYBRIMI AUTOSERV
        S.R.L., Informațiile pe care le obținem din alte surse, cum ar fi
        autorităţi publice sau private, agenții de prevenire a fraudelor, precum
        și de alți furnizori de date. Acestea includ date demografice, date
        referitoare la interese, precum și comportamentul la navigarea online.
        Istoric al oferirii unor avantaje, reduceri, discounturi pentru
        recompensarea fidelităţii clientului. Nivelul serviciilor care vi se
        prestează; de exemplu, probleme operaţionale și alte evenimente care pot
        afecta serviciile noastre; Răspunsurile la invitaţii şi confirmările de
        participare la evenimente Datele cu caracter personal sensibile
        dezvăluie originea dumneavoastră rasiala şi etnica, opiniile politice,
        convingerile religioase şi filozofice, afilierea sindicală, datele
        genetice, datele biometrice, datele referitoare la sănătate sau datele
        referitoare la viaţa sau orientarea sexuală.
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        SC. HYBRIMI AUTOSERV S.R.L. nu colectează de la dumneavoastră în mod
        intenţionat date cu caracter personal sensibile pentru a le stoca.
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Datele personale pe care le prelucrăm sunt, în principal, datele
        dumneavostra de identificare, tranzacţionale, financiare, demografice,
        de localizare sau alte date personale pe care le colectam direct de la
        dumneavoastră sau din alte surse atunci când deveniţi clientul nostru
        sau când folosiţi serviciile noastre.
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        Temeiul juridic al prelucrarii
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Baza legala pentru colectarea si procesarea datelor dumneavoastra pentru
        fiecare din scopurile mentionate mai sus este: Contractul de furnizare
        sau prestari servicii la care dumneavoastra sunteti parte sau cererea
        dumneavoastra inainte de incheierea unui contract pentru care am primit
        consimțământul dumneavoastră; Interesele comerciale legitime ale
        Societății, de exemplu, prevenirea fraudelor, menținerea securității
        serviciilor noastre, marketing direct și îmbunătățirea serviciilor
        noastre. Ori de câte ori ne bazăm pe acest temei juridic pentru a
        prelucra datele dvs., evaluăm interesele noastre comerciale pentru a ne
        asigura că acestea nu prevalează asupra drepturilor dvs. În plus, în
        unele cazuri aveți dreptul de a vă opune acestei prelucrări. Interesul
        legitim al Societatii pentru a ne permite exercitarea drepturilor
        prevazute de lege in favoarea noastra, pentru a actiona in justitie
        contra oricarei activitati ilegale sau care prejudiciaza Societatea
        Conformarea cu o cerință legală imperativă, de exemplu, cerințe
        contabile și fiscale, care fac obiectul unor politici interne stricte
        cum ar fi perioadele de păstrare, proceduri, și dreptul dvs. de a
        restricționa utilizarea datelor proprii, care controlează obiectul
        serviciilor noastre ce vor fi prestate; În plus, în masura în care aţi
        fost de acord, consimtamantul dumneavoastra. Prelucrarea datelor cu
        caracter personal în baza consimtamantului reprezintă un scop aditional
        prelucrării datelor personale în vederea executării contractului la care
        sunteti parte şi nu condiţionează furnizarea/prestarea serviciilor
        contractuale.
      </p>
      <p style={{ color: "black", marginTop: "20px" }}>
        Vom colecta datele dvs. cu caracter personal atunci când, de exemplu:
        Cumpărați sau utilizați oricare dintre produsele și serviciile noastre;
        Vă înregistrați pentru un anumit produs sau serviciu; Ne contactați prin
        diverse canale, sau ne solicitați informații în legătură cu un produs
        sau serviciu; Ați acordat permisiunea altor societăți, cum ar fi
        partenerii noștri comerciali sau asociații noștri, precum și unor terți
        furnizori sau contractanți ai noștri, să facă schimb de informații cu
        noi cu privire la dvs.; Atunci când datele dvs. cu caracter personal
        sunt publice; sau Sunteți clientul/beneficiarul unei activități
        comerciale pe care o achiziționăm/prestam. De asemenea, colectăm
        informații de la anumite organizații, dacă este cazul și în măsura în
        care avem temeiuri legale în acest sens. Acestea includ agenții de
        prevenire a fraudelor, anuare comerciale, agenții de verificare/control,
        agenții de calculare a facturii și prestatori servicii contractate
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        3.Categoriile de destinatari catre care se pot divulga datele personale
        colectate:
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Pentru a atinge scopurile mai sus prevazute, utilizam urmatoarele
        categorii de furnizori de produse si servicii/ imputerniciti :
        furnizorii implicati in mod direct/indirect in furnizarea produselor si
        prestarea serviciilor din domeniul turismului intern si international;
        autoritatile statului (inclusiv autoritati fiscale); contabili,
        auditori, experti judiciari, avocati sau alti asemenea consilieri
        externi ai Societatii sau catre terte persoane care furnizeaza produse
        si servicii companiei (furnizorii de servicii de paza, de sisteme IT,
        consultanti financiari) furnizorii Societatii implicati in mod
        direct/indirect in procesul de marketing si promovare.
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>4.Durata pastrarii</h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Vom păstra informațiile dumneavoastră, care pot include date personale
        atât timp cât este necesar să vă furnizăm servicii, să respectăm legile
        aplicabile, să soluționăm litigii cu orice parte și altfel, dacă este
        necesar, pentru a ne permite să ne desfășurăm activitatea, inclusiv
        pentru a detecta și a preveni frauda sau alte activități ilegale. De
        exemplu avem obligația de a păstra documentele aferente tranzacțiilor
        financiare 10 ani de la încheierea exercițiului financiar în care au
        fost prelucrate. Toate datele personale pe care le păstrăm vor fi supuse
        acestei Politici de confidențialitate. Dacă aveți o întrebare despre o
        anumită perioadă de păstrare pentru anumite tipuri de date personale pe
        care le procesăm despre dumneavoastră, vă rugăm să ne contactați prin
        intermediul detaliilor de contact incluse mai jos.
      </p>
      <h5 style={{ color: "black", marginTop: "20px" }}>
        5.Drepturile dumneavoastra
      </h5>
      <p style={{ color: "black", marginTop: "20px" }}>
        Regulamentul conferă persoanelor cărora li se prelucrează date personale
        o serie de drepturi. Astfel, pe lângă drepturile existente în prezent,
        regăsim şi dreptul la portabilitatea datelor şi pe cel de stergere a
        datelor. Pe scurt, drepturile pe care le aveţi: Dreptul de a retrage
        oricând un consimtamânt dat în vederea opririi unei prelucrari a datelor
        care se bazeaza pe consimtamântul dvs. Retragerea nu va afecta
        legalitatea prelucrarii pe baza consimtamântului acordat înainte de
        retragere, pentru executarea unui contract, in vederea indeplinirii unei
        obligatii legale sau in scopul urmaririi intereselor noastre legitime.
        Dreptul de acces – înseamnă că aveţi dreptul de a obţine o confirmare
        din partea noastră că prelucrăm sau nu datele cu caracter personal care
        vă privesc şi, în caz afirmativ, aveţi acces la datele respective şi la
        informaţiile privind modalitatea în care sunt prelucrate aceste date.
        Dreptul la portabilitatea datelor – se referă la dreptul de a primi
        datele personale într-un format structurat, utilizat în mod curent de
        către noi şi care poate fi citit automat, dar şi la dreptul ca aceste
        date să fie transmise direct altui operator, dacă acest lucru este
        fezabil din punct de vedere tehnic. Dreptul la opozitie – vizează
        dreptul dumneavoastră de a vă opune prelucrării datelor personale atunci
        când prelucrarea este necesară pentru îndeplinirea unei sarcini care
        serveşte unui interes public sau când are în vedere un interes legitim
        al operatorului. Atunci când prelucrarea datelor cu caracter personal
        are drept scop marketingul direct sau prelucrări efectuate în baza
        consimţământului expres, aveţi dreptul de a vă opune prelucrarii în
        orice moment. Dreptul la rectificare – se referă la corectarea, fără
        întârzieri nejustificate, a datelor cu caracter personal inexacte.
        Rectificarea va fi comunicată fiecarui destinatar la care au fost
        transmise datele, cu excepţia cazului în care acest lucru se dovedeşte
        imposibil sau presupune eforturi disproporţionate. Dreptul la ştergerea
        datelor („dreptul de a fi uitat”) – înseamnă că aveţi dreptul de a
        solicita ştergerea datelor cu caracter personal, fără întârzieri
        nejustificate, în cazul în care se aplică unul dintre următoarele
        motive: acestea nu mai sunt necesare pentru îndeplinirea scopurilor
        pentru care au fost colectate sau prelucrate; vă retrageţi
        consimţământul şi nu există niciun alt temei juridic pentru prelucrare;
        vă opuneţi prelucrării şi nu există alte motive legitime care să
        prevaleze; datele cu caracter personal au fost prelucrate ilegal; datele
        cu caracter personal trebuie şterse pentru respectarea unei obligaţii
        legale; datele cu caracter personal au fost colectate în legătură cu
        oferirea de servicii ale societăţii informationale. Dreptul la
        restricţionarea prelucrării – poate fi exercitat în cazul în care
        persoana contesta exactitatea datelor, pe o perioadă necesară
        verificării corectitudinii datelor; prelucrarea este ilegală, iar
        dumneavoastră vă opuneţi ştergerii datelor cu caracter personal,
        solicitând în schimb restricţionarea; în cazul în care SC AUTO UTIL SERV
        & PARTS SRL nu mai are nevoie de datele cu caracter personal în scopul
        prelucrării, dar persoana i le solicită pentru constatarea, exercitarea
        sau apărarea unui drept în instanţă; în cazul în care persoana s-a opus
        prelucrării pentru intervalul de timp în care se verifică dacă
        drepturile legitime ale operatorului prevalează asupra celor ale
        persoanei respective. Dreptul de a depune o plangere – plângeri
        referitoare la prelucrarea datelor personale pot fi adresate Autorităţii
        Naţionale de Supraveghere a Prelucrării Datelor cu Caracter Personal.
        Pentru exercitarea acestor drepturi, precum si pentru orice intrebari
        suplimentare cu privire la aceasta informare sau in legatura cu
        utilizarea de catre Societate a datelor personale, va rugam sa
        contactati ofiterul nostru pentru protectia datelor, alegand oricare din
        modalitatile de comunicare descrise mai jos.
      </p>
    </div>
  );
};

export const CreditsData = function () {
  return (
    <div>
      <h1 style={{ color: "black" }}>Instrumente structurale</h1>
      <p style={{ color: "black", marginTop: "20px" }}>
        https://mfe.gov.ro/progresele-pocu-in-ultimul-semestru-12-miliarde-euro-apeluri-lansate-si-1-miliard-euro-contracte-semnate/instrumente_structurale/
      </p>
      <h1 style={{ color: "black" }}>Guvernul romaniei</h1>
      <a
        href="https://getlogovector.com/guvernul-romaniei-logo-vector-svg/"
        target="_blank"
      >
        <img
          style={{ width: "200px" }}
          src="https://getlogovector.com/wp-content/uploads/2020/05/guvernul-romaniei-logo-vector.png"
        />
      </a>
      <h1 style={{ color: "black" }}>Uniunea europeana</h1>
      <a href="https://www.freepik.com/free-vector/illustration-european-union-flag_2922296.htm#query=ue%20logo&position=1&from_view=keyword&track=ais">
        Image by rawpixel.com
      </a>
      on Freepik Image by <h1 style={{ color: "black" }}>Contact image</h1>
      <a href="https://www.freepik.com/free-photo/young-business-man-working-her-desk-with-laptop-smartphone_21076020.htm#page=4&query=contact%20us&position=33&from_view=search&track=ais">
        Freepik
      </a>
      <a href="https://pixabay.com/images/id-6943487/" target="_blank">
        Image from PIXBAY
      </a>
      <a href="https://pixabay.com/images/id-7770695/" target="_blank">
        Image from PIXBAY
      </a>
    </div>
  );
};
